import { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  CardMedia,
  CardActions,
  Grid,
  Tooltip,
  Paper
} from '@mui/material';
import { Delete, Add, CheckCircle } from '@mui/icons-material';
import { useUpdatePropertyMutation } from '../../store/docApi';
import { useDeleteImageMutation } from '../../store/mediaApi';
import FileUpload from './FileUpload';

export default function PictureManager({ item }) {
  const imgUrl = 'https://m.stitchso.com/img/';
  const [updateProperty] = useUpdatePropertyMutation();
  const [deleteImage] = useDeleteImageMutation();
  const [showAddPicture, setShowAddPicture] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteUrl, setDeleteUrl] = useState('');

  function addPicture() {
    setShowAddPicture(true);
  }

  function deletePictureConfirm(url) {
    setDeleteUrl(url);
    setDeleteConfirmOpen(true);
  }

  function deletePicture() {
    setDeleteConfirmOpen(false);
    if (deleteUrl.startsWith(imgUrl)) {
      deleteImage({ name: deleteUrl.substr(imgUrl.length) });
    }
    const newPictures = item.pictures.filter((el) => el !== deleteUrl);
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: 'pictures', value: newPictures });
  }

  function setPicture(picture) {
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: 'picture', value: picture });
  }

  function getPictureName(picture) {
    const tok = picture.split('/');
    return tok[tok.length - 1];
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Pictures</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={addPicture} size="small">
          Add Picture
        </Button>
      </Box>

      {item.pictures && item.pictures.length > 0 ? (
        <Grid container spacing={2}>
          {item.pictures.map((picture, i) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
              <Card
                sx={{
                  position: 'relative',
                  border: 'none'
                }}
              >
                <CardMedia
                  component="img"
                  image={picture}
                  alt={getPictureName(picture)}
                  sx={{
                    height: 200,
                    objectFit: 'cover'
                  }}
                />
                <CardActions
                  sx={{
                    justifyContent: 'space-between',
                    bgcolor: 'background.paper',
                    borderTop: 1,
                    borderColor: 'divider'
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '60%'
                    }}
                  >
                    {getPictureName(picture)}
                  </Typography>
                  <Box>
                    <Tooltip title={picture === item.picture ? 'Main picture' : 'Set as main picture'}>
                      <IconButton
                        color={picture === item.picture ? 'primary' : 'default'}
                        onClick={() => setPicture(picture)}
                        size="small"
                        sx={picture !== item.picture ? { color: 'action.disabled' } : {}}
                      >
                        <CheckCircle />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete picture">
                      <IconButton color="error" onClick={() => deletePictureConfirm(picture)} size="small">
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Paper
          sx={{
            p: 3,
            textAlign: 'center',
            bgcolor: 'background.default'
          }}
        >
          <Typography color="text.secondary">No pictures added yet. Click "Add Picture" to get started.</Typography>
        </Paper>
      )}

      {showAddPicture && (
        <Box sx={{ mt: 2 }}>
          <FileUpload folder={item.pk} item={item} />
        </Box>
      )}

      <Dialog open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Delete Picture</DialogTitle>
        <DialogContent>
          <Typography>Delete this picture?</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setDeleteConfirmOpen(false)}>
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={deletePicture}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
